"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LookupFieldLogic = void 0;
const field_logic_1 = require("../../field-type-registry/field-logic");
const fields_logic_registry_1 = require("../../field-type-registry/fields-logic-registry");
const comparisons_1 = require("../../comparisons/comparisons");
const fields_1 = require("../../utils/fields");
const registry_helpers_1 = require("../../field-type-registry/registry-helpers");
const intl_1 = require("../../locale/intl");
const lookup_fieldtype_1 = require("../../safe-field-value/calculated-fields/lookup-field/lookup.fieldtype");
const texts_1 = require("../../texts");
const linked_record_1 = require("../../utils/linked-record");
const lookup_1 = require("../../utils/lookup");
const target_field_1 = require("../../utils/target-field");
const view_control_rules_1 = require("../../utils/view-control-rules");
const array_1 = require("../../helpers/array");
const react_fast_compare_1 = __importDefault(require("react-fast-compare"));
class LookupFieldLogic extends field_logic_1.BaseFieldTypeLogic {
    constructor() {
        super(...arguments);
        this.aggregates = {};
        this.name = "lookupfield";
        this.label = (0, intl_1.$t)(texts_1.lookupFieldText.lookup);
        this.icon = "lookup";
        this.iconColor = "#17C4C4";
        this.placeholder = "";
        this.searchSynonyms = [(0, intl_1.$t)(texts_1.lookupFieldText.mirror)];
        this.isCalculated = true;
        this.uneditableFieldError = (0, intl_1.$t)(texts_1.lookupFieldText.a_linked_record_field_is_required);
        this.fieldValueGetter = new lookup_fieldtype_1.LookupFieldValueGetter();
        this.isReference = true;
    }
    prepareValueForClipboard(value, field, userPreferences, record) {
        return (0, lookup_1.prepareValueForClipboardFromTargetField)(value, field, userPreferences, record);
    }
    prepareFieldDataToClipboard(field) {
        const defaultData = super.prepareFieldDataToClipboard(field);
        return (0, target_field_1.withTargetField)(field, defaultData, (targetField, targetFieldLogic) => targetFieldLogic.prepareFieldDataToClipboard(targetField));
    }
    getComparisonsOptions(field) {
        return (0, target_field_1.withTargetField)(field, [], (targetField, targetFieldLogic) => targetFieldLogic.getComparisonsOptions(targetField));
    }
    getSortsOptions(field) {
        return (0, target_field_1.withTargetField)(field, [], (targetField) => (0, fields_logic_registry_1.getFieldLogic)((0, registry_helpers_1.getFieldType)(targetField)).getSortsOptions(targetField));
    }
    getComparisons(field, rule) {
        return (0, target_field_1.withTargetField)(field, comparisons_1.stubTrueComparisons, (targetField, targetFieldType) => {
            const [targetSlug] = (0, target_field_1.retrieveTargetFieldSlug)(field, targetField, rule.field);
            const filterRule = { ...rule, field: targetSlug };
            const comparisons = targetFieldType.getComparisons(targetField, filterRule);
            return (0, lookup_1.getLookupComparisonsForTargetField)(targetField.field_type, comparisons);
        });
    }
    getFilterComponentData(field, comparison) {
        return (0, target_field_1.withTargetField)(field, {}, (targetField, targetFieldLogic) => {
            return {
                placeholder: targetFieldLogic.placeholder,
                field: targetField,
                ...targetFieldLogic.getFilterComponentData(targetField, comparison),
            };
        });
    }
    getInlineEditRules(field) {
        return {
            ...super.getInlineEditRules(field),
            editOnStartTyping: false,
            switchToInputControl: "OnCellSelect",
            editorWidth: "100%",
            allowAddRecordToGroup: false,
        };
    }
    getViewControlRules(field) {
        if (!field.params.target_field_structure) {
            return (0, view_control_rules_1.getInvalidFieldViewControlRules)();
        }
        const rules = (0, target_field_1.withTargetField)(field, super.getViewControlRules(field), (targetField, targetFieldType) => targetFieldType.getViewControlRules(targetField));
        return {
            ...rules,
            nestedFieldsInFieldsToDisplay: "hide",
            nestedFieldsInSort: "hide",
            nestedFieldsInFilter: "hide",
            nestedFieldsInGroup: "hide",
            nestedFieldsInSpotlight: "hide",
        };
    }
    // @ts-expect-error: Need to resolve
    sortField(field) {
        return (0, target_field_1.withTargetField)(field, null, (targetField, targetFieldType) => {
            return targetFieldType.sortField(targetField);
        });
    }
    // @ts-expect-error: Need to resolve
    filterField(field) {
        return (0, target_field_1.withTargetField)(field, null, (targetField, targetFieldType) => {
            const filterByField = targetFieldType.filterField(targetField);
            return (0, lookup_1.replaceWithLookupSlug)(field, filterByField);
        });
    }
    getEmptyFilterValue(field, comparison) {
        return (0, target_field_1.withTargetField)(field, null, (targetField, targetFieldType) => {
            return targetFieldType.getEmptyFilterValue(targetField, comparison);
        });
    }
    isValueEmpty(fieldValue, field) {
        if (!Array.isArray(fieldValue)) {
            return true;
        }
        return (0, lookup_1.isTargetFieldValueEmpty)(fieldValue, field);
    }
    sortKey(fieldValue, field, userPreferences, record, structure, rule) {
        if (!Array.isArray(fieldValue)) {
            return [];
        }
        return (0, lookup_1.getSortKeyFromTargetField)(fieldValue, field, userPreferences, record, structure, rule);
    }
    useSortCache(field) {
        return (0, target_field_1.withTargetField)(field, true, (targetField, fieldLogic) => fieldLogic.useSortCache(targetField));
    }
    useNaturalSorting(field, fieldValue, isGroupByRule) {
        return (0, target_field_1.withTargetField)(field, true, (targetField, fieldLogic) => fieldLogic.useNaturalSorting(targetField, fieldValue, isGroupByRule));
    }
    groupBySortKey(fieldValue, field, userPreferences, record, structure, rule) {
        if (!Array.isArray(fieldValue)) {
            return [];
        }
        return (0, lookup_1.getGroupBySortKeyFromTargetField)(fieldValue, field, userPreferences, record, structure, rule);
    }
    groupByKey(fieldValue, field, userPreferences, record, structure) {
        if (!Array.isArray(fieldValue)) {
            return "";
        }
        return (0, lookup_1.getGroupByKeyFromTargetField)(fieldValue, field, userPreferences, record, structure);
    }
    getGroupValues(fieldValue, field, record, userPreferences) {
        if (!Array.isArray(fieldValue) || !fieldValue.length) {
            return [this.getEmptyValue()];
        }
        return (0, lookup_1.getGroupValuesFromTargetField)(fieldValue, field, record, userPreferences);
    }
    searchKey(fieldValue, field, userPreferences, record) {
        if (!Array.isArray(fieldValue)) {
            return "";
        }
        return (0, lookup_1.getSearchKeyFromTargetField)(fieldValue, field, userPreferences, record);
    }
    valueToString(fieldValue, field, userPreferences, record) {
        if (!Array.isArray(fieldValue)) {
            return "";
        }
        return (0, lookup_1.getValueToStringFromTargetField)(fieldValue, field, userPreferences, record);
    }
    processFilterValue(filterValue, comparison, field, userPreferences) {
        return (0, target_field_1.withTargetField)(field, "", (targetField, targetFieldLogic) => targetFieldLogic.processFilterValue(filterValue, comparison, targetField, userPreferences));
    }
    processFieldValue(record, slug, comparison, field, userPreferences) {
        return (0, target_field_1.withTargetField)(field, [], (targetField, targetFieldTypeLogic) => {
            if (!targetField) {
                return [];
            }
            const lookupValue = (0, fields_1.getValueFromRecordByField)(record, field);
            const stubRecords = lookupValue.reduce((result, group) => [
                ...result,
                ...(0, lookup_1.generateLookupStubRecords)(group, targetField),
            ], []);
            const [targetSlug, nested] = (0, target_field_1.retrieveTargetFieldSlug)(field, targetField, slug);
            let filterByFiledLogic = targetFieldTypeLogic;
            let filterByField = targetField;
            let valueByField = targetField;
            if (nested) {
                filterByFiledLogic = (0, fields_logic_registry_1.getFieldLogic)(nested.field_type);
                filterByField = nested;
                valueByField = (0, fields_1.getAppFieldBySlug)([targetField], targetSlug);
            }
            return stubRecords
                .filter((stubRecord) => {
                if (!filterByFiledLogic.shouldCleanUpEmptyInLookupFilter(comparison)) {
                    return true;
                }
                const value = (0, fields_1.getValueFromRecordByField)(stubRecord, valueByField);
                return !filterByFiledLogic.isValueEmpty(value, filterByField);
            })
                .map((stubRecord) => targetFieldTypeLogic.processFieldValue(stubRecord, targetSlug, comparison, targetField, userPreferences));
        });
    }
    processFieldValueForFiltering(record, slug, comparison, field, userPreferences) {
        return (0, target_field_1.withTargetField)(field, [], (targetField, targetFieldTypeLogic) => {
            if (!targetField) {
                return [];
            }
            const lookupValue = (0, fields_1.getValueFromRecordByField)(record, field);
            const stubRecords = lookupValue.reduce((result, group) => [
                ...result,
                ...(0, lookup_1.generateLookupStubRecords)(group, targetField),
            ], []);
            const [targetSlug, nested] = (0, target_field_1.retrieveTargetFieldSlug)(field, targetField, slug);
            let filterByFiledLogic = targetFieldTypeLogic;
            let filterByField = targetField;
            let valueByField = targetField;
            if (nested) {
                filterByFiledLogic = (0, fields_logic_registry_1.getFieldLogic)(nested.field_type);
                filterByField = nested;
                valueByField = (0, fields_1.getAppFieldBySlug)([targetField], targetSlug);
            }
            return stubRecords
                .filter((stubRecord) => {
                if (!filterByFiledLogic.shouldCleanUpEmptyInLookupFilter(comparison)) {
                    return true;
                }
                const value = (0, fields_1.getValueFromRecordByField)(stubRecord, valueByField);
                return !filterByFiledLogic.isValueEmpty(value, filterByField);
            })
                .map((stubRecord) => targetFieldTypeLogic.processFieldValueForFiltering(stubRecord, targetSlug, comparison, targetField, userPreferences));
        });
    }
    filterValueToString(filterValue, field, userPreferences, comparison) {
        return (0, target_field_1.withTargetField)(field, "", (targetField, targetFieldLogic) => targetFieldLogic.filterValueToString(filterValue, targetField, userPreferences, comparison));
    }
    progressWidgetGoalValueToString(fieldValue, field, userPreferences) {
        return (0, target_field_1.withTargetField)(field, "0", (targetField, targetFieldLogic) => targetFieldLogic.progressWidgetGoalValueToString(fieldValue, targetField, userPreferences));
    }
    metricWidgetValueToString(fieldValue, field, userPreferences) {
        return (0, target_field_1.withTargetField)(field, "0", (targetField, targetFieldLogic) => targetFieldLogic.metricWidgetValueToString(fieldValue, targetField, userPreferences));
    }
    hasUneditableFieldError(field, application) {
        return !(0, linked_record_1.hasLinkedFields)(application);
    }
    getEmptyValue() {
        return [];
    }
    getCommonFieldParams(field) {
        var _a, _b;
        return {
            ...(_b = (_a = field.params) === null || _a === void 0 ? void 0 : _a.target_field_structure) === null || _b === void 0 ? void 0 : _b.params,
            ...super.getCommonFieldParams(field),
            system: false,
            primary: false,
        };
    }
    getNestedFields(field) {
        return (0, target_field_1.withTargetField)(field, super.getNestedFields(field), (targetField, targetFieldLogic) => {
            if (!targetFieldLogic) {
                return [];
            }
            return targetFieldLogic
                .getNestedFields(targetField)
                .filter((nestedField) => !(0, registry_helpers_1.isHiddenField)(nestedField));
        });
    }
    canHaveReferencedRecords() {
        return true;
    }
    /**
     * Get referenced records from both linked and target fields.
     */
    getReferencedRecords(fieldValue, field, record, structure) {
        if (!Array.isArray(fieldValue)) {
            return [];
        }
        return [
            ...(0, lookup_1.getReferencedRecordsFromLinkedField)(field, record, structure),
            ...(0, lookup_1.getReferencedRecordsFromTargetField)(fieldValue, field, record, structure),
        ];
    }
    showSystemLockIcon() {
        return true;
    }
    getDuplicateFieldOptions() {
        return {
            includeContentChecked: true,
            includeContentDisabled: true,
        };
    }
    canChangeValue() {
        return false;
    }
    getInitialParams(field, structure) {
        const linkedField = (0, linked_record_1.getDefaultLinkedFieldSlug)(field, structure);
        return {
            linked_field: linkedField,
        };
    }
    getLinkedRecordFieldSmartWidth(_field) {
        return {
            defaultWidht: 170,
            minWidth: 90,
        };
    }
    getRecordTitleVariableValue(variableName, fieldValue, field, userPreferences, record) {
        return (0, lookup_1.getValueToStringFromTargetField)(fieldValue, field, userPreferences, record, ", ");
    }
    getFieldAppTargetStructure(field) {
        return (0, target_field_1.withTargetField)(field, field, (targetField) => {
            return targetField;
        });
    }
    isSupportedByBulkAction() {
        return false;
    }
    getRelatedRecordRequestsGetter(field) {
        return (0, target_field_1.withTargetField)(field, null, (targetField, targetFieldLogic) => {
            const targetRelatedRecordRequestsGetter = targetFieldLogic.getRelatedRecordRequestsGetter(targetField);
            if (targetRelatedRecordRequestsGetter === null) {
                return null;
            }
            return (fieldValue) => {
                if (!fieldValue) {
                    return [];
                }
                const requests = (0, lookup_1.mergeLookupGroups)(fieldValue).map(targetRelatedRecordRequestsGetter);
                return (0, array_1.removeDuplicates)((0, array_1.flattenOnce)(requests), (request) => request.recordId);
            };
        });
    }
    getFieldValue(field, record) {
        const lookupValue = super.getFieldValue(field, record);
        if (!lookupValue)
            return [];
        return (0, target_field_1.withTargetField)(field, [], (targetField, targetFieldTypeLogic) => {
            return lookupValue.map((group) => {
                const stubRecords = (0, lookup_1.generateLookupStubRecords)(group, targetField);
                return stubRecords.map((stubRecord) => targetFieldTypeLogic.getFieldValue(targetField, stubRecord));
            });
        });
    }
    isValueEqual(fieldValue1, fieldValue2, field, userPreferences) {
        return (0, react_fast_compare_1.default)(fieldValue1, fieldValue2);
    }
}
exports.LookupFieldLogic = LookupFieldLogic;
